namespace HA.Core.Entity {
    export class PageHead extends Entity {
        /**
         *
         * @param data
         */
        public add2Head(data?: App) {
            // log(['add2Head::E', data.getTag().getAttribute('appName')]);
        }
    }
}
